import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Card, makeStyles, CardActionArea, CardMedia, CardContent, Typography, CardActions, Button, Chip, Divider } from '@material-ui/core'
import DoneIcon from '@material-ui/icons/Done'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SliderQuestion from './questionTypes/Slider'

const useStyles = makeStyles(theme => ({
    root: {},
    card: {},
    titleRow: {
        display: 'flex',
        flexWrap: 'wrap',
        wordBreak: 'break-all',
        paddingTop: theme.spacing(0.5)
    },
    titleWrapper: {
        flexGrow: 1,
        ...theme.isMobile && {
            //width: '100%'
        }
    },
    title: {
        textAlign: 'left!important',
        marginTop: `0px!important`,
        marginRight: theme.spacing(1)
    },
    priceWrapper: {},
    price: {
        textAlign: 'right!important',
        marginTop: `0px!important`,
        color: theme.palette.primary.main + '!important'
    },
    chip: {
        color: 'rgba(0, 0, 0, 0.61)',
        backgroundColor: '#eeeeee',
        fontWeight: 600,
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(0.75),
        '&:last-child': {
            marginRight: 0
        }
    },
    chipIcon: {
        marginLeft: theme.spacing(1) + 'px!important'
    },
    smallDescription: {
        color: 'rgba(0,0,0,0.61)',
        fontSize: '1rem'
    }
}))

const defaultPrice = 51800
const defaultMonths = 72

function ExternalProduct({ className, product, ...rest }) {
    const classes = useStyles()
    const [price, setPrice] = useState(defaultPrice / defaultMonths)

    if (!product) {
        return null
    }

    const onValueChange = (id, value) => {
        setPrice(value > 0 ? defaultPrice / value : 0)
    }

    const numberFormat = number => {
        return number ? Math.round(number) : 0
    }

    return (
        <Box className={classes.root} mb={2}>
            <Card className={classes.card} variant="outlined">
                <CardMedia
                    component="img"
                    alt="Contemplative Reptile"
                    height="180"
                    image="https://dsu2f16ugr2z8.cloudfront.net/800x600,fit/autotalliprodmedia/images/used_cars2/greyhen/359/JT-5543/1617271718915/mercedes-benz-a-2020_00_original.jpg"
                    title="Contemplative Reptile"
                />
                <CardContent>
                    <Box className={classes.titleRow}>
                        <Box className={classes.titleWrapper}>
                            <Typography gutterBottom variant="h5" component="h3" className={classes.title}>
                                MERCEDES-BENZ A
                            </Typography>
                        </Box>
                        <Box className={classes.priceWrapper}>
                            <Typography gutterBottom variant="h5" component="h3" className={classes.price}>
                                <small className={classes.smallDescription}>arvio</small> {numberFormat(price) + '€/kk'}
                            </Typography>
                        </Box>
                    </Box>
                    <Typography variant="body2" color="textSecondary" component="p">
                        250 e A Business AMG EQ Power(19.A)
                    </Typography>
                    <Box mt={2} mb={-0.75}>
                        <Chip
                            className={classes.chip}
                            label="Hybridi"
                            icon={<FontAwesomeIcon fixedWidth className={classes.chipIcon} size="lg" icon={['far', 'charging-station']} />}
                        />
                        <Chip
                            className={classes.chip}
                            label="Hatchback"
                            icon={<FontAwesomeIcon fixedWidth className={classes.chipIcon} size="lg" icon={['far', 'car']} />}
                        />
                        <Chip
                            className={classes.chip}
                            label="7000 km"
                            icon={<FontAwesomeIcon fixedWidth className={classes.chipIcon} size="lg" icon={['far', 'steering-wheel']} />}
                        />
                        <Chip
                            className={classes.chip}
                            label="2020"
                            icon={<FontAwesomeIcon fixedWidth className={classes.chipIcon} size="lg" icon={['far', 'calendar-week']} />}
                        />
                    </Box>
                    <Box my={2} mx={-2}>
                        <Divider variant="middle" />
                    </Box>
                    <Box my={2} mx={-1}>
                        <SliderQuestion
                            question={{
                                id: -1,
                                min: 3,
                                max: 120,
                                name: 'kuukaudet',
                                step: 3,
                                title: 'Kuinka pitkän leasingin haluat?',
                                type: 'slider',
                                unit: 'kk',
                                useLogaritmic: false,
                                value: defaultMonths,
                                xsCols: 12,
                                validation: null
                            }}
                            value={defaultMonths}
                            onValueChanged={onValueChange}
                            theme={null}
                        />
                    </Box>
                </CardContent>
            </Card>
        </Box>
    )
}

ExternalProduct.propTypes = {
    className: PropTypes.string
}

export default ExternalProduct
